import { createFromIconfontCN } from '@ant-design/icons'

const Icon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4013419_ypxcwf2v5z.js'
})

// eslint-disable-next-line no-restricted-exports
export { Icon as default }
